import { supabase } from '@/lib/supabase'
import type { Plan, PlanInterval } from '../types'
import { normalizePlan } from '../utils/normalizePlan'

export async function listPlans(params?: { search?: string; page?: number; pageSize?: number }): Promise<{ items: Plan[]; total: number }>{
  const page = params?.page ?? 1
  const pageSize = params?.pageSize ?? 25
  const from = (page - 1) * pageSize
  const to = from + pageSize - 1

  let q = supabase.from('plans').select('*', { count: 'planned' }).order('created_at', { ascending: false }).range(from, to)
  if (params?.search) {
    const s = `%${params.search}%`
    q = q.or(`name.ilike.${s},slug.ilike.${s}`)
  }
  const { data, error, count } = await q
  if (error) throw error
  const items = (data as any[] | null) ?? []
  // Normaliza campos quando o schema remoto usa features como envelope
  const norm: Plan[] = items.map((row: any) => normalizePlan(row))
  return { items: norm, total: count ?? 0 }
}

export type UpsertPlanInput = {
  id?: string
  slug: string
  name: string
  description?: string
  // Pode ser lista de recursos (string[]) ou envelope com configurações (ex.: { list: string[], discount_percent: number })
  features?: string[] | Record<string, any>
  amount_cents: number
  currency?: string
  interval?: PlanInterval
  visible?: boolean
  active?: boolean
}

export async function upsertPlan(payload: UpsertPlanInput): Promise<{ id: string }>{
  const { error, data } = await supabase.functions.invoke('admin-upsert-plan', { body: payload })
  if (error) throw error
  return { id: (data as any)?.id as string }
}

export async function deletePlan(id: string, archiveStripe = false): Promise<void>{
  const { error } = await supabase.functions.invoke('admin-delete-plan', { body: { id, archiveStripe } })
  if (error) throw error
}
